import { extend } from 'vee-validate';
import { validator } from './runtime';

extend('uploader', {
    ...validator,
    message: 'The file you have selected is not valid to upload'
});
